import React from 'react';
import {
    Form, Tooltip, message, Row, Col, Input
} from 'antd';
import 'antd/dist/antd.css';

let video;
let canvas;
let context;

//访问用户媒体设备的兼容方法
function getUserMedia(constraints, success, error) {
    if (navigator.mediaDevices.getUserMedia) {
        //最新的标准API
        navigator.mediaDevices.getUserMedia(constraints).then(success).catch(error);
    } else if (navigator.webkitGetUserMedia) {
        //webkit核心浏览器
        navigator.webkitGetUserMedia(constraints, success, error)
    } else if (navigator.mozGetUserMedia) {
        //firfox浏览器
        navigator.mozGetUserMedia(constraints, success, error);
    } else if (navigator.getUserMedia) {
        //旧版API
        navigator.getUserMedia(constraints, success, error);
    }
}
//访问成功
function success(stream) {
    //兼容webkit核心浏览器
    video.srcObject = stream;
    video.play();
}
//访问失败
function error(error) {
    message.error(`访问用户媒体设备失败${error.name}, ${error.message}`);
}

class WindowPhotoPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            btnState: '连接设备',
            init: false,
            imgBase64: ''
        }
    }
    componentDidMount() {
        this.camaeraLink();
    }
    //摄像头连接
    camaeraLink = () => {
        video = document.getElementById('video');
        canvas = document.getElementById('imgCanvas');
        context = canvas.getContext('2d');
        if (navigator.mediaDevices.getUserMedia || navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia) {
            //调用用户媒体设备, 访问摄像头
            getUserMedia({ video: { width: 220, height: 320 } }, success, error);
            this.setState({ btnState: '头像采集', init: true });
            context.font = "30px Arial";
            context.strokeText("点我拍照", 50, 150);
        } else {
            message.info('当前客户端不支持用户访问摄像头');
        }
    }
    //拍照
    cameraClick = () => {
        if (this.state.btnState === '连接设备') {
            this.camaeraLink();
        }
        else if (this.state.btnState === '头像采集') {
            context.drawImage(video, 0, 0, 220, 320);
            var dataUrl = canvas.toDataURL('image/png');//注意这里背景透明的话，需要使用png
            this.setState({ imgBase64: dataUrl });
            this.props.form.setFieldsValue({
                imgstr: dataUrl
            });
        }
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form layout="inline" id="photoWindow">
                <Row gutter={2}>
                    <Col span={12}>
                        <video id="video" width="220" height="320" style={{ border: 'solid 1px #ccc' }} controls></video>
                    </Col>
                    <Col span={12}>
                        <div style={{ width: '100%', cursor: 'pointer' }} onClick={() => this.cameraClick()} >
                            <Tooltip title={this.state.btnState === '连接设备' ? '点我连接摄像头' : '点我拍照'} placement="right" style={{ cursor: 'pointer' }}>
                                <canvas id="imgCanvas" width="220" height="320" style={{ border: 'solid 1px #ccc' }}></canvas>
                            </Tooltip>
                        </div>
                    </Col>
                </Row>
                <Row gutter={1} style={{ display: 'none' }}>
                    <Col span={24}>
                        <Form.Item>
                            {getFieldDecorator('imgstr', {})(
                                <Input name="imgstr" readOnly style={{ width: '460px' }} />
                            )}
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        );
    }
}
const WrapWindowPhotoPage = Form.create({ naem: 'photo_window' })(WindowPhotoPage);
export default WrapWindowPhotoPage